export default __webpack_public_path__ + "8ee1fe2c7b35ad01e3d932c7f8260407.svg";